import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import type { ChildRouteContext } from "@/root";

import { fetchEntriesQueryOptions } from "@/modules/handbook/user/services";

import HandbookList from "../../../../components/HandbookList";

export const Route = createFileRoute("/_panel/_handbook/handbook/entries/")({
  component: Component,
  beforeLoad: ({ context }) =>
    ({
      crumb: [
        {
          label: context.t("Handbook", { ns: "handbook.shared" }),
        },
      ],
    }) satisfies ChildRouteContext,
  loader: (opts) =>
    opts.context.queryClient.prefetchQuery(fetchEntriesQueryOptions()),
});

function Component() {
  const { t } = useTranslation("handbook.shared");

  return (
    <Container title={t("Handbook")}>
      <HandbookList />
    </Container>
  );
}
